/**
 * Single source of truth for responsive breakpoints.
 *
 * Plain CommonJS so `tailwind.config.js` can `require` it at build time and
 * app code (e.g. a `useBreakpoint` hook) can import the same numbers at
 * runtime. Change a value here and both CSS prefixes (`sm:`, `md:`, ...) and
 * JS `matchMedia` queries move together.
 *
 * Meaning: (none) phone portrait, sm phone landscape / small tablet,
 * md tablet, lg desktop, xl wide desktop. Mobile is the base style.
 */
const breakpoints = { sm: 640, md: 768, lg: 1024, xl: 1280 };

/**
 * Tailwind `theme.screens` shape: `{ sm: '640px', md: '768px', ... }`.
 * @returns {Record<keyof typeof breakpoints, string>}
 */
function toScreens() {
  return Object.fromEntries(
    Object.entries(breakpoints).map(([name, px]) => [name, `${px}px`])
  );
}

module.exports = { ...breakpoints, breakpoints, toScreens };
